import React, { FC } from 'react';
import classNames from 'classnames';
import {
  SystemButtonDefault,
  SystemButtonProps,
  SystemButtonContent,
} from '../SystemButton';
import styles from './brand_button.module.scss';

type Props = SystemButtonProps & {
  large?: boolean;
};

export const BrandButton: FC<Props> = ({
  children,
  large,
  onClick,
  type,
  iconLeft,
  iconRight,
  disabled,
  dataName,
  id,
}) => {
  const commonProps = {
    className: classNames(styles.brand, {
      [styles.large]: large,
      [styles.small]: !large,
    }),
    disabled,
    name: dataName,
    id,
  };
  if (type === 'submit') {
    return (
      <button type="submit" {...commonProps}>
        <SystemButtonContent iconLeft={iconLeft} iconRight={iconRight}>
          {children}
        </SystemButtonContent>
      </button>
    );
  }
  return (
    <button type="button" onClick={onClick} {...commonProps}>
      <SystemButtonContent iconLeft={iconLeft} iconRight={iconRight}>
        {children}
      </SystemButtonContent>
    </button>
  );
};

BrandButton.defaultProps = { ...SystemButtonDefault, large: false };
